<template>
  <div class="form-group" :class="{ 'required': required, 'has-error': errors.length }">
    <label :for="name">{{ titleValue }}</label>
    <div class="additional-info" v-if="$slots['info']">
      <slot name="info"/>
    </div>
    <form-textarea v-bind="$props" :placeholder="placeholderValue"/>
    <p class="help-block info" v-if="$slots['help']">
      <slot name="help"/>
    </p>
    <p class="help-block error" v-for="(error, i) in errors" :key="`${name}-error-${i}`">{{ error }}</p>
  </div>
</template>

<script>
import FormTextarea from '@/views/components/form/FormTextarea'

export default {
  name: 'FormGroupTextarea',
  components: {
    FormTextarea
  },
  props: {
    title: { type: String, default: '' },
    ...FormTextarea.props
  },
  computed: {
    errors () { return this.model.errors },
    titleValue () { return this.title ? this.title : this.$helpers.Str.titleCase(this.name) },
    placeholderValue () { return typeof this.placeholder === 'undefined' ? this.titleValue : this.placeholder }
  }
}
</script>
